<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="7"> 
				<el-input clearable placeholder="请输入类型名称" v-model="searchInfo.name">
					<template slot="prepend">类型名称</template>
				</el-input>
			</el-col>
			<el-col :span="9"> 
				<el-button type="primary" @click="searchSysConfig" icon="el-icon-search">搜索</el-button>
				<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="addStall">新增</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="loctypeList"  style="width: 100%"  max-height="700">
			    <el-table-column fixed="left" prop="name" width="220" label="名称"  align="center"></el-table-column>
			    <el-table-column prop="code" label="编码"  width="220" align="center"></el-table-column>
			    <el-table-column prop="idx" label="排序" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goSysConfigDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Stall">详情</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="sysconfigTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<LocTypeDetail @needRefrash="needRefrash" :selectconfig="selectconfig"></LocTypeDetail>
		</el-dialog>
	</div>
</template>

<script>
	import dayjs from 'dayjs'
	import {queryLocTypePage } from '/static/apiUrl.js'
	import LocTypeDetail from './loctypedetail.vue'
	export default {
		name : 'LocTypeList',
		data() {
			return {
				detailShow: false,
				editok : false,
				detailTitle: '详情',
				selectconfig: null,	
				searchInfo:{
					name: '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				sysconfigTotal : 0,
				loctypeList : [],				
			}
		},
		mounted() {
			this.initData()
			this.queryLocTypes()
		},
		components: {
			LocTypeDetail,
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryLocTypes()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryLocTypes()
			},
			initData() {
			},
			searchSysConfig(){
				this.param.page = 1
				this.loctypeList = []
				this.queryLocTypes()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.param.page = 1
				this.queryLocTypes()
			},
			queryLocTypes(){
				this.loctypeList = []
				queryLocTypePage({
					name : this.searchInfo.name,
					pagenum : this.param.page,
					pagesize : this.param.pagenum
				}).then(res => {
					if(0 == res.code){
						this.sysconfigTotal = res.datas.totalnum
						res.datas.data.forEach((sysconfig) => {
							this.loctypeList.push(sysconfig)
						})
					}
				})
			},
			goSysConfigDetail(idx,row){
				this.detailTitle = '位置类型详情'
				this.selectconfig = JSON.parse(JSON.stringify(this.loctypeList[idx]))
				this.detailShow = true
			},
			addStall(){
				this.detailTitle = "新增位置类型"
				this.selectconfig = null
				this.detailShow = true
			},
			needRefrash(val,isshow){
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				if(this.editok){
					this.queryLocTypes()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>